import {useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'

import {backendGetRequest} from '../../../common/utils/requests'

type CheckoutStatus = 'pending' | 'completed' | 'canceled' | null

const poolingIntervalInMsMap = {
  Ethereum: 20000,
  Bitcoin: 90000,
  Tron: 15000,
}
const maxAttemptCount = 20

export default function CheckoutPolling({
  checkoutId,
  accountId,
  network,
}: {
  checkoutId: string
  accountId: number
  network: 'Bitcoin' | 'Ethereum' | 'Tron'
}) {
  const history = useHistory()
  const poolingInterval = poolingIntervalInMsMap[network] ?? 15000

  useEffect(() => {
    let attemptCount = 1

    const poll = (intervalId?: number) => {
      const clearPoolInterval = () => {
        if (intervalId) window.clearInterval(intervalId)
      }

      attemptCount++
      backendGetRequest(`/api/v2/dashboard/dfns/checkout-status/${checkoutId}`, true)
        .then((res) => {
          if (res.ok) return res.json()
          throw new Error(`Polling failed: ${res.status} ${res.statusText}`)
        })
        .then((nextStatus: CheckoutStatus) => {
          if (!['completed', 'canceled'].includes(nextStatus ?? '')) return

          clearPoolInterval()
          if (nextStatus === 'completed') {
            return void history.push(`/payments/${accountId}/deposit/result/success`)
          }
          return void history.push('/')
        })
        .catch(() => {
          clearPoolInterval()
        })
    }

    poll()
    const intervalId = window.setInterval(() => {
      if (attemptCount >= maxAttemptCount) return void window.clearInterval(intervalId)
      poll(intervalId)
    }, poolingInterval)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [checkoutId, accountId, history, poolingInterval])

  return <CircularProgress size={24} color="inherit" />
}
